<ion-segment (ionChange)="handleSegmentChanged($event)" mode="md" value="{{ defaultTabSelectedKey }}">
	<ion-segment-button *ngFor="let tabEl of tabElements" value="{{ tabEl.key }}">
		<ion-label>{{ tabEl.label }}</ion-label>
	</ion-segment-button>
</ion-segment>
